import { clerkPlugin } from '@clerk/vue'
import axios from 'axios'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import VueTippy from 'vue-tippy'

import { REQUEST_TIMEOUT } from '@/api/base'
import i18n from '@/i18n'
import { LOGIN_APP_ROUTES } from '@/routes/login-app-routes'
import { store } from '@/store'
import { DROP_LIST_THEMES } from '@/utils/components-configurations/app-droplist'
import { webAppRefererRouteInjectionKey } from '@/utils/injection-keys'
import { getPluginOptions } from '@jira/app'
import { LOGIN_APP_PLUGIN_OPTIONS } from '@root/template-options-keys'
import { getOriginalRootElement } from '@shared-modules/utils/entry-points'

import LoginApp from '../LoginApp'

import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'
import 'tippy.js/themes/translucent.css'

import '@/assets/styles/root.scss'
import '@/assets/styles/app.scss'

export const configure = async () => {
  const rootElement = getOriginalRootElement()

  const { apiBase, ...rest } = getPluginOptions(LOGIN_APP_PLUGIN_OPTIONS, rootElement)

  axios.defaults.baseURL = apiBase || window.origin
  axios.defaults.timeout = REQUEST_TIMEOUT

  const app = createApp(LoginApp)
  app.use(i18n)
  app.use(VueTippy, {
    component: 'AppTippy',
    defaultProps: {
      placement: 'bottom',
      theme: DROP_LIST_THEMES.TRANSLUCENT_NEXT,
      arrow: false,
      offset: [0, 5]
    }
  })
  const router = createRouter({
    history: createWebHistory(),
    routes: LOGIN_APP_ROUTES
  })

  app.use(router)
  app.use(store)

  await router.isReady()

  app.provide(webAppRefererRouteInjectionKey, router.currentRoute)

  store.dispatch('appContext/setUrls', rest)
  app.use(clerkPlugin, {
    publishableKey: process.env.VUE_APP_WEB_APP_CLERK_CLIENT_ID,
    appearance: {
      theme: 'simple',
      options: {
        // logoPlacement: 'outside',
        socialButtonsVariant: 'blockButton',
        logoImageUrl: 'https://static.oboard.io/logo.svg',
        termsPageUrl: 'https://oboard.io/legal/eula-web-okr-app',
        privacyPageUrl: 'https://oboard.io/privacy-policy'
      }
    }
  })
  app.mount(rootElement)
}

configure()
